import { TransportModeDefault } from './TransportModeDefault';
import { AgeGenderDistribution } from './AgeGenderDistribution.model';
import { AgeGenderLuggageFaktor } from './AgeGenderLuggageFaktor.model';
import { LuggageSize } from './LuggageSize.model';
import { StorageAcceptance } from './StorageAcceptance.model';
import { TravelMixData } from './TravelMixData.model';
import { AgeGenderStorageFactor } from './AgeGenderStorageFactor.model';
import { AgeGenderAdaptation } from './AgeGenderAdaption.model';
import { PassengerChangeTimeVector } from './PassengerChangeTimeVector.model';
import { DoorWidthReduction } from './DoorWidthReduction.model';
import { BaseValueTime } from './BaseValueTime.model';
import { BaseFactor } from './BaseFactor.model';
import { PolynomialFactor } from './PolynomialFactor.model';
import { AisleWidth } from './AisleWidth.model';
import { AlternativeRooms } from './AlternativeRooms.model';
import { AccessibilityOfTheSeats } from './AccessibilityOfTheSeats.model';
import { AmountOfNotStorableBaggage } from './AmountOfNotStorableBaggage.model';
import { SimplicityLuggageAccommodation } from './SimplicityLuggageAccommodation.model';
import { LuggageRacksWhenBoarding } from './LuggageRacksWhenBoarding.model';
import { BaggageAccumulation } from './BaggageAccumulation.model';
import { ReservationObligation } from './ReservationObligation.model';
import { CompartmentsAvailable } from './CompartmentsAvailable.model';
import { SeatsPerRunningMeter } from './SeatsPerRunningMeter.model';
import { AgeDistribution } from './AgeDistribution.model';
import { AgeGenderAdaptationSteps } from './AgeGenderAdaptionSteps.model';
import { PassengerChangeTimeVectorSteps } from './PassengerChangeTimeVectorSteps.model';
import { StepsWidthFactor } from './StepsWidthFactor.model';
import { BoardingPlaceDensityOfPeopleFactor } from './BoardingPlaceDensityOfPeopleFactor.model';
import { LocationWaysFactor } from './LocationWaysFactor.model';
import { DoorWidthAndPhysicalSeparationFactor } from './DoorWidthAndPhysicalSeparationFactor.model';
import { SecurityAdjustmentFactor } from './SecurityAdjustmentFactor.model';
import { LuggagePerFoldingSeat } from './LuggagePerFoldingSeat.model';

export class Region {
  id: number;
  name: string;
  createdAtUtc;
  publishStateId:number;
  publishStateName:string;
  ageGenderDistribution: AgeGenderDistribution;
  ageGenderLuggageFaktorId: number;
  transportModeDefaults: TransportModeDefault[];
  isDefaultRegion:boolean;
}

export class RegionWithState {
  id: number;
  regionName: string;
  regionCreation;
  ageGenderDistributionId: number;
  ageGenderLuggageFaktorId: number;
  stateId: number;
  stateName: string;
  isDefaultRegion:boolean;
}

export class RegionData {
  id: number;
  name: string;
  createdAtUtc;
  ageGenderDistribution: AgeGenderDistribution;
  ageGenderLuggageFaktor: AgeGenderLuggageFaktor;
  ageGenderStorageFactor: AgeGenderStorageFactor;
  luggageSize: LuggageSize;
  storageAcceptance: StorageAcceptance;
  travelMixes: TravelMixData[];
  defaults: TransportModeDefault[];
  ageGenderAdaptation: AgeGenderAdaptation;
  passengerChangeTimeVector: PassengerChangeTimeVector;
  doorWidthReduction: DoorWidthReduction;
  doorWidthAndPhysicalSeparationFactor: DoorWidthAndPhysicalSeparationFactor;
  baseValueTime: BaseValueTime;
  baseFactor: BaseFactor;
  polynomialFactor: PolynomialFactor;
  aisleWidth: AisleWidth;
  alternativeRooms: AlternativeRooms;
  accessibilityOfTheSeats: AccessibilityOfTheSeats;
  amountOfNotStorableBaggage: AmountOfNotStorableBaggage;
  simplicityLuggageAccommodation: SimplicityLuggageAccommodation;
  luggageRacksWhenBoarding: LuggageRacksWhenBoarding;
  baggageAccumulation: BaggageAccumulation;
  reservationObligation: ReservationObligation;
  compartmentsAvailable: CompartmentsAvailable;
  seatsPerRunningMeter: SeatsPerRunningMeter;
  ageDistribution: AgeDistribution;
  ageGenderAdaptationSteps: AgeGenderAdaptationSteps;
  passengerChangeTimeVectorSteps: PassengerChangeTimeVectorSteps;
  stepsWidthFactor: StepsWidthFactor;
  boardingPlaceDensityOfPeopleFactor: BoardingPlaceDensityOfPeopleFactor;
  locationWaysFactor: LocationWaysFactor;
  oppositeDoorReductionFactorValue: number;
  beforeSeatReductionFactorValue: number;
  notUsableSeatFactorValue: number;
  securityAdjustmentFactor: SecurityAdjustmentFactor;
  distanceBetweenPeople: number;
  distanceBetweenPeopleAisle: number;
  distanceBetweenPeopleStairs: number;
  rackCapacityRoundingThreshold: number;
  minimumUnderSeatHeight: number;
  overheadHeightReductionFactor: number;
  overheadLengthReductionFactor: number;
  overheadLengthReductionThreshold: number;
  handleReductionFactor: number;
  luggagePerFoldingSeat: LuggagePerFoldingSeat;
  overencumberFactor: number;
}

export class RegionTable {
  id: number;
  name: string;
  createdAtUtc;
  ageGenderDistributionId: number;
  ageGenderLuggageFactorId: number;
  ageGenderStorageFactorId: number | null;
  oppositeDoorReductionFactorValue: number;
  beforeSeatReductionFactorValue: number;
  notUsableSeatFactorValue: number;
  distanceBetweenPeople: number;
  distanceBetweenPeopleAisle: number;
  distanceBetweenPeopleStairs: number;
  rackCapacityRoundingThreshold: number;
  minimumUnderSeatHeight: number;
  overheadHeightReductionFactor: number;
  overheadLengthReductionFactor: number;
  overheadLengthReductionThreshold: number;
  handleReductionFactor: number;
  luggagePerFoldingSeat: LuggagePerFoldingSeat;
  overencumberFactor: number;
}